<template>
  <div>
    <h1 class="heading text-4xl">Well Done {{ user }}!</h1>
    <h3 class="font-semibold font-main text-2xl mt-3">Score: {{ score }}</h3>
    <h3 class="font-semibold font-main text-2xl mb-3">
      Time: {{ time / 1000 }}s
    </h3>
    <router-link
      v-if="$route.path.includes('lockdown')"
      class="button blue mx-2"
      to="/lockdown"
      >Return Home</router-link
    >
    <router-link v-else class="button blue mx-2" to="/"
      >Return Home</router-link
    >
    <!--router-link
      v-if="$route.path.includes('lockdown')"
      class="button green mx-2"
      to="/lockdown/results"
      >View Results</router-link
    -->
  </div>
</template>
<script>
export default {
  props: {
    user: {
      type: String,
      default: '',
    },
    score: {
      type: String,
      default: '',
    },
    time: {
      type: Number,
      default: 0,
    },
  },
}
</script>
